// The device's sign-in. Only the session token is stored; the passphrase never is.
import { useSyncExternalStore } from "react";
import { ConvexError } from "convex/values";

const KEY = "vladrss.session";
let token: string | null = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
const listeners = new Set<() => void>();
const resets = new Set<() => void>();
export function onSessionReset(reset: () => void) { resets.add(reset); return () => resets.delete(reset); }

export function setToken(t: string | null) {
  if (token && t !== token) resets.forEach((reset) => reset());
  token = t;
  try { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); } catch { /* ignore */ }
  listeners.forEach((l) => l());
}
export const getToken = () => token;
export const useToken = () => useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => token);

/** Error code carried by a ConvexError from the backend, if any. */
export function errorCode(e: unknown): string | null {
  if (e instanceof ConvexError && e.data && typeof e.data === "object" && "code" in e.data) return String((e.data as { code: unknown }).code);
  return null;
}
